import { cn } from '@/lib/utils';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';

export const Label: FC<PropsWithChildren<HTMLAttributes<HTMLLabelElement>>> = ({ children, className, ...props }) => {
  return (
    <label {...props} className={cn('text-secondary-std text-sm', className)}>
      {children}
    </label>
  );
};
